export const MAIN_PAGE_PATH = '/'
export const SIGN_IN_PATH = '/sign-in'
export const SIGN_UP_PATH = '/sign-up'
export const RESTORE_PASSWORD_PATH = '/restore-password'
export const CREATE_APPOINTMENT_PAGE_PATH = "/make-appointment"
export const CABINET_APPOINTMENTS_PATH = "/cabinet/appointments"
export const CABINET_RESOLUTION_PATH = "/cabinet/resolutions"
export const CABINET_PROFILE_PATH = "/cabinet/profile"
export const CABINET_PATIENTS_PATH = "/cabinet/patients"
